import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const MenuBar = ({ editor }) => {
  if (!editor) return null;
  const buttons = [
    { label: "G",       title: "Gras",           action: () => editor.chain().focus().toggleBold().run(),                  active: editor.isActive("bold"),           style: { fontWeight: "bold" } },
    { label: "I",       title: "Italique",        action: () => editor.chain().focus().toggleItalic().run(),                active: editor.isActive("italic"),         style: { fontStyle: "italic" } },
    { label: "S",       title: "Barré",           action: () => editor.chain().focus().toggleStrike().run(),                active: editor.isActive("strike"),         style: { textDecoration: "line-through" } },
    { label: "U",       title: "Souligné",        action: () => editor.chain().focus().toggleUnderline().run(),             active: editor.isActive("underline"),      style: { textDecoration: "underline" } },
    { label: "H1",      title: "Titre 1",         action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),   active: editor.isActive("heading", { level: 1 }) },
    { label: "H2",      title: "Titre 2",         action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),   active: editor.isActive("heading", { level: 2 }) },
    { label: "• List",  title: "Liste à puces",   action: () => editor.chain().focus().toggleBulletList().run(),            active: editor.isActive("bulletList") },
    { label: "1. List", title: "Liste numérotée", action: () => editor.chain().focus().toggleOrderedList().run(),           active: editor.isActive("orderedList") },
    { label: "❝",       title: "Citation",        action: () => editor.chain().focus().toggleBlockquote().run(),            active: editor.isActive("blockquote") },
    { label: "—",       title: "Séparateur",      action: () => editor.chain().focus().setHorizontalRule().run(),           active: false },
    { label: "↩",       title: "Annuler",         action: () => editor.chain().focus().undo().run(),                       active: false },
    { label: "↪",       title: "Rétablir",        action: () => editor.chain().focus().redo().run(),                       active: false },
  ];
  return (
    <div className="ph-menubar">
      {buttons.map((btn, i) => (
        <button key={i} title={btn.title}
          className={`ph-menubar-btn ${btn.active ? "ph-menubar-btn--active" : ""}`}
          style={btn.style || {}} onClick={btn.action} type="button">
          {btn.label}
        </button>
      ))}
    </div>
  );
};

const TabConclusion = ({ form, onChange }) => {
  const editor = useEditor({
    extensions: [StarterKit],
    content: form.data || "",
    onUpdate: ({ editor }) => onChange("data", editor.getHTML()),
  });

  useEffect(() => {
    if (editor && form.data !== editor.getHTML()) {
      editor.commands.setContent(form.data || "");
    }
  }, []);

  return (
    <div className="ph-conclusion">

      {/* ── Éditeur conclusion ── */}
      <div className="ph-editor-wrapper">
        <MenuBar editor={editor} />
        <EditorContent editor={editor} className="ph-editor" />
      </div>

      <div className="ph-divider" />

      {/* ── Date prochain RDV ── */}
      <div className="ph-field-group">
        <label>Date prochain RDV</label>
        <input type="date"
          value={form.date_prochain_rdv ?? ""}
          onChange={(e) => onChange("date_prochain_rdv", e.target.value)} />
      </div>

      {/* ── Motif ── */}
      <div className="ph-field-group">
        <label>Motif</label>
        <input type="text" placeholder="Préciser le motif du prochain RDV..."
          value={form.motif ?? ""}
          onChange={(e) => onChange("motif", e.target.value)} />
      </div>

    </div>
  );
};

export default TabConclusion;